import request from '../utils/request'
export const mobileLoginNoOpen = data =>
    request({
        url: '/yax/v1/userLoginApi/mobileLoginNoOpen',
        method: "POST",
        data
    });
export const mobileGzhLogin = data =>
    request({
        url: '/yax/v1/userLoginApi/mobileGzhLogin',
        method: "POST",
        data
    });
export const sendSmsYzm = data =>
    request({
        url: '/basic/init/sysApi/sendSmsYzm',
        method: "POST",
        data
    });
export const gzhCodeGetOpenId = data =>
    request({
        url: '/basic/weixin/weChatApi/gzhCodeGetOpenId/'+data.code,
        method: "GET",
        data
    });
export const appIdLogin = data =>
    request({
        url: '/yax/v1/userLoginApi/appIdLogin',
        method: "POST",
        data
    });